import { InfiniteData } from "@tanstack/react-query";

import { Paginated } from "@/services/types";

export const flattenPages = <TData>(data: InfiniteData<Paginated<TData>>) =>
  data?.pages?.flatMap((x) => x.elements);

export const selectElements = <TData>(data: Paginated<TData>) => data.elements;
